export const debounce = (callback, wait) => {
    let timeout = null;
    return (...args) => {
        const next = () => callback(...args);
        window.clearTimeout(timeout);
        timeout = window.setTimeout(next, wait);
    };
};
